import { Box, Center, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SourcingEventStatus, SourcingEventV2Dto } from "../../../../autogen/bff-api";
import { AwardOutcome } from "./AwardOutcome";
import { ProductAwardSummary } from "./ProductAwardSummary";
import { SelectWinner } from "./SelectWinner";

export const AwardTab = ({ event }: { event: SourcingEventV2Dto }) => {
  const { t } = useTranslation();

  switch (event.status) {
    case SourcingEventStatus.Evaluation:
      return (
        <Box>
          <SelectWinner event={event} />
          <ProductAwardSummary event={event} />
        </Box>
      );
    // A completed evaluation is locked but not yet awarded — the buyer awards from here.
    // If the event was already awarded before being completed, show the read-only outcome.
    case SourcingEventStatus.Completed:
      return (
        <Box>
          {event.award ? <AwardOutcome event={event} readOnly /> : <SelectWinner event={event} />}
          <ProductAwardSummary event={event} />
        </Box>
      );
    case SourcingEventStatus.AwardDecision:
    case SourcingEventStatus.Awarded:
      return (
        <Box>
          <AwardOutcome event={event} />
          <ProductAwardSummary event={event} />
        </Box>
      );
    case SourcingEventStatus.Closed:
      return (
        <Box>
          <AwardOutcome event={event} readOnly />
          <ProductAwardSummary event={event} />
        </Box>
      );
    case SourcingEventStatus.Cancelled:
      return (
        <Center py="16">
          <Text color="smMuted">{t("This procurement has been cancelled")}</Text>
        </Center>
      );
    default:
      return (
        <Center py="16">
          <Text color="smMuted">
            {t("Awarding becomes available once bidding is closed and bids are under evaluation.")}
          </Text>
        </Center>
      );
  }
};
